import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { type AircallNumbersListStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/store/AircallNumbersListStore'

type IRefreshNumbersButtonProps = {
  store: AircallNumbersListStore
}

export const RefreshNumbersButton = observer(({ store }: IRefreshNumbersButtonProps) => {
  const { loading, isRefreshDisabled, refreshButtonLabel, refreshNumbers } = store

  return (
    <IconButton
      iconProps={{ fontSize: 16 }}
      tooltipProps={{
        label: refreshButtonLabel,
        placement: 'top',
      }}
      variant={'icon'}
      color={'tertiary'}
      size={'small'}
      icon={loading ? 'loading3' : 'refresh'}
      ariaLabel='Refresh_data'
      onClick={refreshNumbers}
      disabled={isRefreshDisabled}
    />
  )
})
